import { render } from "./Tabs.vue?vue&type=template&id=25ad2f09&ts=true"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tabs/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25ad2f09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25ad2f09', __exports__)) {
    api.reload('25ad2f09', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=25ad2f09&ts=true", () => {
    api.rerender('25ad2f09', render)
  })

}


export default __exports__